import { z } from 'zod';
import { ListenIdSchema } from './ids.js';
import { TrackSchema } from './track.js';
// Default only — the API's actual LISTEN_THRESHOLD_MS may differ, and states what it's really running with on every history response.
export const LISTEN_THRESHOLD_MS_DEFAULT = 10_000;
export const LISTEN_HISTORY_PAGE_SIZE_DEFAULT = 20;
export const LISTEN_HISTORY_PAGE_SIZE_MAX = 50;
// startedAt is the track's start, which may predate this listener watching it.
// listenedFrom/To are whole-second poll samples; listenedMs is shorter if paused mid-window.
export const ListenSchema = z
    .strictObject({
    id: ListenIdSchema,
    track: TrackSchema,
    listenedMs: z.number().int().nonnegative(),
    startedAt: z.iso.datetime(),
    listenedFrom: z.iso.datetime(),
    listenedTo: z.iso.datetime(),
})
    .readonly();
// Items are newest first.
export const ListeningHistorySchema = z
    .strictObject({
    /** The threshold this server is enforcing, so the client never guesses it. */
    thresholdMs: z.number().int().nonnegative(),
    items: z.array(ListenSchema).readonly(),
})
    .readonly();
// Query strings arrive as strings, hence the coercion.
export const ListeningHistoryQuerySchema = z
    .strictObject({
    limit: z.coerce
        .number()
        .int()
        .min(1)
        .max(LISTEN_HISTORY_PAGE_SIZE_MAX)
        .default(LISTEN_HISTORY_PAGE_SIZE_DEFAULT),
})
    .readonly();
//# sourceMappingURL=listening.js.map